import type { AddressFallbackRecord } from '@navio/nsdk';
import { create } from 'zustand';

interface AddressFallbackStore {
  addressFallback: AddressFallbackRecord | null;
  setAddressFallback: (addressFallback: AddressFallbackRecord | null) => void;
  reset: () => void;
}

const useAddressFallbackStore = create<AddressFallbackStore>((set) => ({
  addressFallback: null,
  setAddressFallback: (addressFallback) => set({ addressFallback }),
  reset: () => set({ addressFallback: null })
}));

export const useAddressFallback = () => useAddressFallbackStore((state) => state.addressFallback);

export const useAddressFallbackActions = () => {
  const setAddressFallback = useAddressFallbackStore((state) => state.setAddressFallback);
  const reset = useAddressFallbackStore((state) => state.reset);
  return { setAddressFallback, reset };
};
